import React from 'react'
import preview1 from '@/assets/images/videos-expertas/video-preview-1.webp'
import preview2 from '@/assets/images/videos-expertas/video-preview-2.webp'
import preview3 from '@/assets/images/videos-expertas/video-preview-3.webp'
export type TVideoInfo = {
  name: string
  personName: React.ReactNode
  avaibleDate: number
  avaibleText: string
  image: string
  url: string
}
const personName1 = (
  <>
    <p className="--priority1">Natalia Cárdenas Zuluaga</p>
    <p>Experta en Bullying y Ciberacoso </p>
    <p>@nataliacardenaspsicologa</p>
  </>
)
const parseDate = (date: number, month: number, year: number) => {
  return new Date(year, month - 1, date).getTime()
}
const videos: TVideoInfo[] = [
  {
    name: 'Bullying: Tipos de observadores',
    avaibleDate: parseDate(2, 4, 2024),
    avaibleText: '2 de Mayo',
    image: preview1,
    personName: personName1,
    url: 'https://youtu.be/2Wi74Gx9RxY',
  },
  {
    name: 'Cómo intervenir en una situación de Bullying',
    avaibleDate: parseDate(9, 5, 2024),
    avaibleText: '9 de Mayo',
    image: preview2,
    personName: personName1,
    url: 'https://youtu.be/sKh5vpWrulc',
  },
  {
    name: 'Diferencia entre Bullying, broma y conflicto',
    avaibleDate: parseDate(16, 5, 2024),
    avaibleText: '16 de Mayo',
    image: preview3,
    personName: personName1,
    url: 'https://youtu.be/SGOIBWcviiI',
  },
]

export default videos
